// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { PermitToWorkGeometryModel } from "../../../../../api/APIClient";

export enum ViewerMode {
    Default = 1,
    AssetInfo,
    PermitsToWork,
    PowerBI,
    PowerBIonModel,
    AssetControl,
    AssetHealth,
    AssetTemperature,
    AssetPresure,
    AssetConexions,
    AssetSelected,
    AlarmsHeatMap,
    EditAsset,
    Navigaion,
    // Prueba3DModel,
    // Calendar,
    Planning,
    Interferences,
    Resources,
    Coordinates,
    BlindFlanges,
    BlindFlangesRoute,
    PrototypeViews,
    SharedByURLPrototypeViews,
}

export interface IPermitToWorkGeometryToCollisions {
    permitId: string;
    // shape: string;
    center: THREE.Vector3;
    radius: number;
    height: number;
    boundingBox: ISizeVector3;
}

export interface IShowLabelsPermitsToWork {
    tag: string;
    id: string;
}

export interface ISizeVector3 {
    sizeX: number;
    sizeY: number;
    sizeZ: number;
}

export interface IRuleSetCollisionResult {
    mesh1: { asset: string; meshId: string };
    mesh2: { asset: string; meshId: string };
}

export interface IPermitToWorkCollision {
    id: string;
    dbIds: number[];
    geometry: PermitToWorkGeometryModel | undefined;
}

export interface ILabelInfo {
    id: string;
    title: string;
    data: { [key: string]: string };
}

export interface ILabelInfoData {
    title: string;
    text: string;
}

export interface IWOCollisionInfo {
    id: string;
    startDate: Date;
    dueDate: Date;
}

export interface IElementsCollision {
    workOrderId1: string;
    workOrderId2: string;
}

export interface ICollisions {
    collisions: Array<IElementsCollision>;
    workTypes: Array<string>;
}

/* eslint-disable */
export const returnMidValue = (arr: number[]) => {
    // Asegurar que la array no está vacía
    if (arr.length === 0) {
        return null;
    }
    // Calcular el índice del medio
    const midIndex = Math.floor(arr.length / 2);
    let offset = 0;
    while (offset <= midIndex) {
        const indicesToCheck = [midIndex + offset, midIndex - offset];
        for (const index of indicesToCheck) {
            const bbox = window.NOP_VIEWER.getModifiedWorldBoundingBox([arr[index]]);
            const isValid =
            bbox &&
            !(Number.isNaN(bbox.min.x)) &&
            !(Number.isNaN(bbox.min.y)) &&
            !(Number.isNaN(bbox.min.z)) &&
            !(Number.isNaN(bbox.max.x)) &&
            !(Number.isNaN(bbox.max.y)) &&
            !(Number.isNaN(bbox.max.z)) &&
            isFinite(bbox.min.x) &&
            isFinite(bbox.min.y) &&
            isFinite(bbox.min.z) &&
            isFinite(bbox.max.x) &&
            isFinite(bbox.max.y) &&
            isFinite(bbox.max.z);
            if (index >= 0 && index < arr.length && isValid) {
                return arr[index];
            }
        }
        offset++;
    }
    return null;
};
/* eslint-enable */

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const colorNameToRGB = (name: string): { r: number; g: number; b: number } => {
    // Create fake div
    const fakeDiv = document.createElement("div");
    fakeDiv.style.color = name;
    document.body.appendChild(fakeDiv);

    // Get color of div
    const cs = window.getComputedStyle(fakeDiv);
    const rgb = cs.getPropertyValue("color");

    // Remove div after obtaining desired color value
    document.body.removeChild(fakeDiv);

    const sep = rgb.indexOf(",") > -1 ? "," : " ";
    const rgbSplit = rgb.substring(4).split(")")[0].split(sep);
    const rgbArray = rgbSplit.map((value) => parseInt(value, 10));

    return {
        r: rgbArray[0],
        g: rgbArray[1],
        b: rgbArray[2],
    };
};

export const colorHexToVector4 = (colorHex: string, opacity: number | undefined): THREE.Vector4 => {
    const color = new THREE.Color(colorHex);
    return new window.THREE.Vector4(color.r, color.g, color.b, opacity || 1);
};

export const colorHexToRgb = (colorHex: string): THREE.Color => {
    const color = new THREE.Color(colorHex);
    return color;
};

export const convertHexToRGB = (colorHex: string | undefined): string => {
    if (colorHex?.length !== 7 || undefined) {
        return "rgb(255, 255, 255)";
    }
    const color1 = colorHex.slice(1);
    const aRgbHex = color1.match(/.{1,2}/g);
    const aRgb = [parseInt(aRgbHex[0], 16), parseInt(aRgbHex[1], 16), parseInt(aRgbHex[2], 16)];
    const rgb = `rgb(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]})`;
    return rgb;
};

export const covertHexToRgbArray = (hex) => {
    const redColor = parseInt(hex[1] + hex[2], 16);
    const greenColor = parseInt(hex[3] + hex[4], 16);
    const blueColor = parseInt(hex[5] + hex[6], 16);
    const rgb = [redColor, greenColor, blueColor];
    return rgb;
};

export const colorNameToVector4 = (name: string): THREE.Vector4 => {
    // Create fake div
    const fakeDiv = document.createElement("div");
    fakeDiv.style.color = name;
    document.body.appendChild(fakeDiv);

    // Get color of div
    const cs = window.getComputedStyle(fakeDiv);
    const rgb = cs.getPropertyValue("color");

    // Remove div after obtaining desired color value
    document.body.removeChild(fakeDiv);

    const sep = rgb.indexOf(",") > -1 ? "," : " ";
    const rgbSplit = rgb.substring(4).split(")")[0].split(sep);
    const rgbArray = rgbSplit.map((value) => parseInt(value, 10));

    return new window.THREE.Vector4(rgbArray[0] / 255, rgbArray[1] / 255, rgbArray[2] / 255, 1);
};

const getColorDarkness = (color: THREE.Color) => {
    return color.r * 255 * 0.299 + color.g * 255 * 0.587 + color.b * 255 * 0.114;
};

export const checkIfIsLight = (colorHex: string) => {
    const rgbColor = colorHexToRgb(colorHex);
    const colorDarkness = getColorDarkness(rgbColor);
    if (colorDarkness > 180) {
        return true;
    }
    return false;
};

const hslToRgb = (h: number, s: number, l: number): [number, number, number] => {
    let r;
    let g;
    let b;

    if (s === 0) {
        r = l;
        g = l;
        b = l; // achromatic
    } else {
        const hue2rgb = (p: number, q: number, t: number) => {
            let tempT = t;
            if (tempT < 0) tempT += 1;
            if (tempT > 1) tempT -= 1;
            if (tempT < 1 / 6) return p + (q - p) * 6 * tempT;
            if (tempT < 1 / 2) return q;
            if (tempT < 2 / 3) return p + (q - p) * (2 / 3 - tempT) * 6;
            return p;
        };

        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h / 360 + 1 / 3);
        g = hue2rgb(p, q, h / 360);
        b = hue2rgb(p, q, h / 360 - 1 / 3);
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
};

const rgbToHex = (r: number, g: number, b: number): string => {
    const componentToHex = (c: number): string => {
        const hex = c.toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    };

    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
};

export const getColorFromGradient = (current: number, max: number): [number, number, number] => {
    const hue = 120 * (1 - current / max);
    const rgb = hslToRgb(hue, 1, 0.5);
    return rgbToHex(...rgb);
};

export const hslToHex = (h: number, s: number, l: number) => {
    const lScaled = l / 100;
    const a = (s * Math.min(lScaled, 1 - lScaled)) / 100;
    const f = (n: number) => {
        const k = (n + h / 30) % 12;
        const color = lScaled - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0");
    };
    return `#${f(0)}${f(8)}${f(4)}`;
};

export const intersectSphereBox = (sphere: THREE.Sphere, box: THREE.Box3): boolean => {
    const closest = new window.THREE.Vector3(sphere.center.x, sphere.center.y, sphere.center.z);
    // Get box closest point to sphere center by clamping
    closest.clamp(box.min, box.max);

    const distance = sphere.center.distanceToSquared(closest);
    return distance < sphere.radius * sphere.radius;
};

export const getDateXDaysAgo = (numOfDays: number, date = new Date()) => {
    const daysAgo = new Date(date.getTime());
    daysAgo.setDate(date.getDate() - numOfDays);
    return daysAgo;
};

export const getDateXHoursAgo = (numOfHours: number, date = new Date()) => {
    const numberOfMlSeconds = date.getTime();
    const hoursInMlSeconds = numOfHours * 60 * 60 * 1000;
    const newDate = new Date(numberOfMlSeconds - hoursInMlSeconds);
    return newDate;
};
